import { render, staticRenderFns } from "./FeedbackOptionItems.vue?vue&type=template&id=4a8109f8&scoped=true"
import script from "./FeedbackOptionItems.vue?vue&type=script&lang=js"
export * from "./FeedbackOptionItems.vue?vue&type=script&lang=js"
import style0 from "./FeedbackOptionItems.vue?vue&type=style&index=0&id=4a8109f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8109f8",
  null
  
)

export default component.exports